export default "__VITE_ASSET__cd318db6__"